import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface DropdownV2StyleProps {
  disabled: boolean
}
const useStyles = makeStyles<Theme, DropdownV2StyleProps>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${theme.border.outline}`,
    borderRadius: '5px',
    boxSizing: 'border-box',
    padding: '0.118rem',
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    height: 28
  },

  selected: {
    marginLeft: '0.5rem',
    marginRight: '0.5rem',
    fontSize: theme.size.base,
    color: theme.palette.textAlt,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  noSelected: {
    color: '#8F8F8F',
    cursor: 'inherit'
  },

  menu: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '1px solid #EAEAEA',
    boxSizing: 'border-box',
    borderRadius: '7px',
    boxShadow: '0 20px 30px rgba(0, 0, 0, 0.15)',
    padding: '18px',
    background: 'white',
    minWidth: 150
  },

  items: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '2px',

    '& > :not(:last-child)': {
      marginBottom: '2px'
    }
  },

  item: {
    marginLeft: '-10px',
    marginRight: '-10px',
    borderRadius: '4px',
    padding: '10px',
    fontSize: theme.size.base,
    color: '#3C425B',
    cursor: 'pointer',
    transition: 'all 200ms',

    '&:hover': {
      background: '#F5F6F8'
    }
  }
}))

export default useStyles
